import React from "react";
import { GAME_TITLE } from "../../lib/constants";

function Header() {
  return (
    <header>
      <h1 className="font-space-mono">{GAME_TITLE}</h1>
    </header>
  );
}

export default Header;
